module.exports = __webpack_public_path__ + "img/Infogram-icon.03b31ad9.png";